import { render, staticRenderFns } from "./memberWx.vue?vue&type=template&id=04532be4&scoped=true&"
import script from "./memberWx.vue?vue&type=script&lang=js&"
export * from "./memberWx.vue?vue&type=script&lang=js&"
import style0 from "./memberWx.vue?vue&type=style&index=0&id=04532be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04532be4",
  null
  
)

export default component.exports